import { HexalInstance } from '@common/enums';
import { cn, CURRENT_INSTANCE } from '@lib/utils';

interface IUserMessageProps {
  message: string;
}

function UserMessage(props: IUserMessageProps) {
  return (
    <div
      className={cn(
        'question-message-container w-[calc(100%-20px)] md:w-3/4 text-[0.8rem] self-end relative whitespace-normal break-words bg-xircle-secondary text-white mr-5 mb-3 p-3 rounded-xl query-container',
        CURRENT_INSTANCE.name === HexalInstance.Default && 'text-hexal-dark-text-color'
      )}
    >
      {props.message}
    </div>
  );
}

export default UserMessage;
